import { useState, useEffect } from "react";
import axios from "axios";

function CitySearch({ onSelect }) {

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    if (query.length < 3) {
      setResults([]);
      return;
    }

    const delayDebounce = setTimeout(async () => {

      setLoading(true);

      try {

        const response = await axios.get(
          "https://nominatim.openstreetmap.org/search",
          {
            params: {
              q: query,
              format: "json",
              addressdetails: 1,
              limit: 5
            }
          }
        );

        setResults(response.data);

      } catch (error) {
        console.error("Search error:", error);
        setResults([]);
      }

      setLoading(false);

    }, 500); // debounce 500ms

    return () => clearTimeout(delayDebounce);

  }, [query]);

  const selectCity = (city) => {
    setQuery(city.display_name);
    setResults([]);
    onSelect(city.lat, city.lon);
  };

  return (
    <div className="relative w-full">

      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search city..."
        className="w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-luxury-gold outline-none"
      />

      {loading && (
        <div className="absolute bg-white text-gray-800 w-full mt-1 p-3 shadow-lg rounded-lg border border-gray-200 text-sm z-50">
          Searching...
        </div>
      )}

      {results.length > 0 && (
        <div className="absolute bg-white text-gray-800 w-full mt-1 shadow-xl rounded-lg border border-gray-200 max-h-60 overflow-y-auto z-50">

          {results.map((city, index) => (
            <div
              key={index}
              onClick={() => selectCity(city)}
              className="px-4 py-3 hover:bg-gray-100 cursor-pointer text-sm text-gray-800 transition"
            >
              {city.display_name}
            </div>
          ))}

        </div>
      )}

    </div>
  );
}

export default CitySearch;
